import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints } from 'styles/style-constants';

import { SidebarBlock } from '../Sidebar/Sidebar.layout';

export const Sidebar = styled(SidebarBlock)`
    ${respondDown(Breakpoints.md)`display: none;`}
`;
